import { STARDOG_CONTEXT_LOCAL_IRI } from 'bones/constants/iris';
import { DEFAULT_MODEL_NAME } from 'bones/constants/model';
import { VoiceboxSettings } from 'bones/constants/voicebox/settings';
import { isProduction } from 'bones/utils/environment';

export type StardogQueryRequestOptions = {
  'default-graph-uri': string[];
  reasoning?: boolean;
  schema?: string;
};

export const buildStardogQueryRequestOptions = ({
  namedGraphs,
  model,
  reasoning,
}: VoiceboxSettings): StardogQueryRequestOptions => {
  const options: StardogQueryRequestOptions = {
    'default-graph-uri': [STARDOG_CONTEXT_LOCAL_IRI],
  };

  if (namedGraphs.length) {
    options['default-graph-uri'] = namedGraphs;
  }

  if (reasoning) {
    options.reasoning = reasoning;
  }

  if (reasoning && model && model !== DEFAULT_MODEL_NAME) {
    options.schema = model;
  }

  return options;
};

export const makeStardogQueryName = (name: string, ...items: string[]) =>
  isProduction()
    ? /* istanbul ignore next */ name
    : `${name} for ${items.join(', ')}`;
